module.exports = __webpack_public_path__ + "static/media/GoetheFFClan-Bold.8562435d.ttf";